<template>
    <div class="bar_content" :style="{ position: liveRoute ? 'relative' : 'absolute',top: liveRoute ? '0' : '30px' }">
        <div style="position: relative" class="bar-gameView">
            <div class="left_side">
                <van-icon
                @click="goBack()"
                name="arrow-left"
                color="#ffffff"
                size="24px"
                v-show="isShowIconLeft"
                />
            </div>
            <div class="right_side">
                <div class="type_line" @click="openService()">
                    <img src="@/assets/images/agent_type_icon.png" alt="">
                    <span>代理</span>
                </div>
                <div class="type_line" @click="jumpOneRecharge()">
                    <img src="@/assets/images/load_type_icon.png" alt="">
                    <span>充值</span>
                </div>
                <div class="type_line" @click="openService()">
                    <img src="@/assets/images/service_type_icon.png" alt="">
                    <span>客服</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GetUtils from "../../utils/utils";
import { mapState } from "vuex";
export default {
    data() {
        return {
            
        }
    },
    props: ['liveRoute'],
    computed: {
    ...mapState({
      userInfo: (state) => state.info.userInfo,
      channel: (state) => state.home.channel,
    }),
    isShowIconLeft() {
        let i = false
        const path = this.$route.path
        if (GetUtils.getUrlKey("directLive") === '1') {
            if(path.includes("/room") ||
            path.includes("/article") ||
            path.includes("/preview")) {
                i = true
            }else {
                i = false
            }
        }else {
            if( path.includes("/room") || path.includes("/article") || path.includes("/preview")) {
                i = false
            }else {
                i = true
            }
        }
        if(this.channel === 'p2' && !GetUtils.isiOS()) {
            i = true
        } 
        return i
    }
  },
    methods: {
        goBack() {
            let _this = this
            const path = this.$route.path
            if(path.includes("/room") ||
            path.includes("/article") ||
            path.includes("/preview")) {
                if(GetUtils.getUrlKey("backLive") === '1') {
                    _this.$router.push({
                        name: 'home',
                        query: {
                            isH5: GetUtils.getUrlKey("isH5"),
                            productId: GetUtils.getUrlKey("productId"),
                            directLive: GetUtils.getUrlKey("directLive")
                        }
                    })
                }else {
                    _this.$router.go(-1)
                }
            }else {
                // this.$dialog
                // .confirm({
                // title: "温馨提示",
                // message: "如需再次观看ONE游戏直播 <br> 请后台关闭APP应用后重新启动进入",
                // className: "blueStyle blueSp",
                // })
                // .then(() => {
                // _this.jumpOneGame();
                // })
                // .catch((e) => {
                // console.log(e, "跳转失败");
                // });
                if(_this.channel === 'p2' && !GetUtils.isiOS()) {
                    if(GetUtils.getUrlKey("directLive") === '1') {
                        if (window?.AndroidClient.onBackToHome || false) {
                            window?.AndroidClient.onBackToHome();
                            this.$store.commit('SET_SC_SWITCH', true)
                        }
                    }else {
                       _this.jumpOneGame(); 
                    }
                }else {
                    _this.jumpOneGame();
                }
            }
        },
        jumpOneGame() {
            if (GetUtils.getUrlKey("isH5") == "1") {
                let info = {
                    message: "backPage",
                };
                window.parent.postMessage(info, "*");
            } else if (GetUtils.getUrlKey("isH5") == "2") {
                if ((window.onesport && window?.onesport.exitLivePage) || false) {
                    window?.onesport.exitLivePage();
                }
            }
        },
        openService() { //打开客服
            if (GetUtils.getUrlKey("isH5") == "1") {
                let info = {
                    message: "openMiniLive",
                };
                window.parent.postMessage(info, "*");
            }else if(GetUtils.getUrlKey("isH5") == "2") {
                if ((window.onesport && window?.onesport.goMiniCs) || false) {
                    window?.onesport.goMiniCs(null);
                }
            }
        },
        jumpOneRecharge() {
            if (GetUtils.getUrlKey("isH5") == "1") {
                let info = {
                message: "openRecharge",
                };
                window.parent.postMessage(info, "*");
            } else if (GetUtils.getUrlKey("isH5") == "2") {
                if ((window.onesport && window?.onesport.JumpRechargePage) || false) {
                window?.onesport.JumpRechargePage();
                }
            }
            let _this = this
            _this.$sensors.track('live2_click_deposit', {
                LoginName: _this.userInfo.username,
                login_status: 1,
                from: '直播首页'
            })
        },
        openAgent() { //打开米多克代理
            if (GetUtils.getUrlKey("isH5") == "1") {
                const url = `https://miduoke.4mu4f7g.com?username=${this.userInfo.username}`
                let info = {
                    message: "openAgent",
                    url: url
                };
                window.parent.postMessage(info, "*");
            } else if (GetUtils.getUrlKey("isH5") == "2") {
                const url = `https://miduoke.4mu4f7g.com?username=${this.userInfo.username}`
                if ((window.onesport && window?.onesport.goMdkCs) || false) {
                window?.onesport.goMdkCs(url);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bar_content {
 width: 100%;
 top: 15px;
}
.bar-gameView {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  z-index: 99;
}
.type_line {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-left: 18px;
    width: 39px;
    height: 39px;
    img {
        width: 25px;
        height: 25px;
    }
    span {
        color: #FFF;
        font-family: "PingFang SC";
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
}
.left_side {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .agent_load {
        width: 40px;
        height: 16px;
        background-image: url('@/assets/images/agent_icon.png');
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        left: 26px;
    }
}
.right_side {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>